import script from "./TokenWeightInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./TokenWeightInput.vue?vue&type=script&setup=true&lang=ts"

import "./TokenWeightInput.vue?vue&type=style&index=0&id=7d335bf4&scoped=true&lang=css"

import exportComponent from "/Users/jason/u/acsi-ui-balancer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d335bf4"]])

export default __exports__